import { useEffect, useState } from "react";
import { Bot, Sparkles } from "lucide-react";
import { Progress } from "@/components/ui/progress";

interface StepTrainingProgressProps {
  onComplete: () => void;
}

export const StepTrainingProgress = ({ onComplete }: StepTrainingProgressProps) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const duration = 4000; // 4 seconds
    const interval = 50;
    const increment = (interval / duration) * 100;

    const timer = setInterval(() => {
      setProgress((prev) => {
        const next = prev + increment;
        if (next >= 100) {
          clearInterval(timer);
          setTimeout(onComplete, 500);
          return 100;
        }
        return next;
      });
    }, interval);

    return () => clearInterval(timer);
  }, [onComplete]);

  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center space-y-8 max-w-md">
        {/* Icon */}
        <div className="relative inline-block">
          <div className="absolute inset-0 bg-primary/20 rounded-full blur-2xl animate-pulse-soft" />
          <div className="relative bg-primary/10 p-8 rounded-full">
            <Bot className="h-24 w-24 text-primary" />
            <Sparkles className="h-8 w-8 text-primary absolute -top-2 -right-2 animate-pulse" />
          </div>
        </div>

        {/* Text */}
        <div className="space-y-2">
          <h1 className="text-3xl font-bold">Training Sophie AI</h1>
          <p className="text-lg text-muted-foreground">
            We're teaching Sophie AI about your business.
          </p>
          <p className="text-sm text-muted-foreground">
            This will only take a moment…
          </p>
        </div>

        {/* Progress Bar */}
        <div className="space-y-3">
          <Progress
            value={progress}
            className="h-3"
            indicatorClassName="bg-primary"
          />
          <p className="text-sm font-medium text-primary">
            {Math.round(progress)}%
          </p>
        </div>
      </div>
    </div>
  );
};
